import { render, staticRenderFns } from "./forbid.vue?vue&type=template&id=7200ce1f&scoped=true&"
import script from "./forbid.vue?vue&type=script&lang=ts&"
export * from "./forbid.vue?vue&type=script&lang=ts&"
import style0 from "./forbid.vue?vue&type=style&index=0&id=7200ce1f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7200ce1f",
  null
  
)

export default component.exports